<title>{{ ConsentMorePage.htmlTitle }}</title>
<app-banner [banner]="ConsentMorePage.banner" [isCommonBanner]="true" [isDefaultPageBanner]="false"></app-banner>

<div class="container mt-3 minheight">
  <div class="card-body ">
    <p class="card-text " [innerHTML]="ConsentMorePage.belowBody | mdToHtml"></p>
  </div>
</div>
